<script setup lang="ts">
import { VModal } from '@/shared/ui'
import { usePassportRuntimeV2 } from '../model/model'
import PassportRuntimeV2 from './PassportRuntimeV2.vue'

const model = usePassportRuntimeV2()
</script>

<template>
  <VModal width="96%" v-model:show="model.openModal">
    <PassportRuntimeV2
      v-if="model.editObjectId"
      :element-id="model.editObjectId"
      modal
      @close="model.closeHandler"
    />
  </VModal>
</template>

<style lang="scss" scoped>
.passport-runtime-v2 {
  min-height: auto;
}
</style>
